import type {
    TurnstileRenderOptions,
    LibraryConfiguration,
} from '@indeed/bot-detection-multi-captcha-library';
import { TurnstileWidget } from '@indeed/bot-detection-multi-captcha-library';

const turnstileRenderOptions: TurnstileRenderOptions = {
    sitekey: '0x4AAAAAAAxcdCS90IQZX-oi',
    theme: 'auto',
};

const libraryConfiguration: LibraryConfiguration = {
    application: 'indeedMobile',
    appPageName: 'resultsPage',
};

const turnstileWidget: TurnstileWidget = new TurnstileWidget(
    libraryConfiguration,
    turnstileRenderOptions
);

// @ts-ignore
window.resultsPageTurnstile = turnstileWidget;
